import styled from "@emotion/styled";
import { css } from "@emotion/react";

export const AlbumCodeShareCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AlbumActivePreviewItemSharedCss = css`
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center !important;
`;

export const Wrapper = styled.section`
  margin: 100px 0 -50px;
  margin-top: 0px;
  width: 100%;
  @media screen and (max-width: 991px) {
    margin-bottom: 30px;
  }
  @media screen and (max-width: 770px) {
    padding-top: 100px;
  }
  @media screen and (max-width: 570px) {
    padding-top: 70px;
  }
`; 